// extracted by mini-css-extract-plugin
export default {"transferLists":"transfer-modal_transferLists__ZQZPy"};